<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->
<div class="scheme-dark mx-[10%] sm:mx-[4.7%]">
  <div class="flex flex-col sm:w-[60%] md:w-[50%]">
    <p-heading align="start" size="2xl" [tag]="'h1'" class="mt-fluid-2xl lg:text-balance">{{
      'signup.maintenance.heading' | translate
    }}</p-heading>
    <p-text align="start" size="lg" class="mt-fluid-md text-balance">
      {{ 'signup.maintenance.description' | translate }}
    </p-text>
    <div>
      <p-link
        class="mt-fluid-lg"
        [icon]="'arrow-right'"
        [href]="'https://porsche.com'"
        [aria]="{ 'aria-label': 'signup.maintenance.cta.aria' | translate }"
      >
        {{ 'signup.maintenance.cta.label' | translate }}
      </p-link>
    </div>
  </div>
</div>
